import type { IconData } from '@stacksjs/iconify-core'

export const arrowUpRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M17 18a1 1 0 0 1-1-1V8H7a1 1 0 0 1 0-2h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1\"/><path fill=\"currentColor\" d=\"M7 18a1 1 0 0 1-.707-1.707l10-10a1 1 0 0 1 1.414 1.414l-10 10A1 1 0 0 1 7 18\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowUpRight
